<div class="text-muted text-center mt-4 mb-3 small">
    <p class="font-monospace small mb-0 px-4">
        &copy; {{ configuration.appYear }} {{ configuration.appDeveloper }} - All rights reserved.
    </p>
    <p class="font-monospace small mb-0 px-4 fw-semibold">{{ configuration.appTitle }}</p>
    <p class="font-monospace small mb-0 px-4">
        <i class="bi me-2 {{ configuration.appType === 'frontEnd' ? 'bi-front' : 'bi-back' }}"></i>
        Version {{ configuration.appVersion }}
    </p>
</div>